/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import DateHelper from "@/helpers/DateHelper";
import Vue from "vue";

Vue.filter('dateTo_numericFull', DateHelper.to_numericFull)
Vue.filter('dateTo_ccccdLLLLyyyy', DateHelper.to_ccccdLLLLyyyy)
Vue.filter('dateTo_dLLLLyyyy', DateHelper.to_dLLLLyyyy)
Vue.filter('dateTo_HHmm', DateHelper.to_HHmm)
Vue.filter('dateTo_HHmmss', DateHelper.to_HHmmss)
Vue.filter('dateTo_ddLLyyyy', DateHelper.to_ddLLyyyy)
Vue.filter('dateTo_LLLLyyyy', DateHelper.to_LLLLyyyy)
